import PageWrapper from '../components/basic/PageWrapper';
import HeroSection from '../components/components/ProductsPage/HeroSection';
import ProductsPageHelmet from '../components/components/ProductsPage/ProductsPageHelmet';
import ProductsSection from "../components/components/ProductsPage/ProductsSection";

const ProductsPage = () => {
	return (
		<>
			<ProductsPageHelmet />
			<PageWrapper>
				<HeroSection />
				<ProductsSection />
			</PageWrapper>
		</>
	);
};

export default ProductsPage;
